import { registerPlugin } from '@capacitor/core';
const NativeGeocoder = registerPlugin('NativeGeocoder', {
    web: () => import('./web').then((m) => new m.NativeGeocoderWeb()),
});
export * from './definitions';
export { NativeGeocoder };
//# sourceMappingURL=index.js.map